import { render, staticRenderFns } from "./KsMultiselect.vue?vue&type=template&id=64a231a5"
import script from "./KsMultiselect.vue?vue&type=script&lang=js"
export * from "./KsMultiselect.vue?vue&type=script&lang=js"
import style0 from "./KsMultiselect.vue?vue&type=style&index=0&id=64a231a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports